export default "__VITE_ASSET__b38a64e9__"